
import emailValidator from '../../foundation/js/validators/emailValidator'

let hasUserTriedSubmit = false
let usernameValue = ""
const usernameInput = document.getElementById('username')
const usernameError = document.querySelector('#username + .nlx-login-page__error-text')
let forgotPasswordValue = ""
const forgotPasswordInput = document.getElementById('forgotPassword')
const forgotPasswordError = document.querySelector('#forgotPassword + .nlx-login-page__error-text')

window.onload = function() {
    if (usernameInput) usernameValue = usernameInput.value   
    if (forgotPasswordInput) forgotPasswordValue = forgotPasswordInput.value   
}

if (usernameInput) {
    usernameInput.addEventListener('input', function (event) {
        usernameValue = event.target.value
        if (hasUserTriedSubmit) {
            displayErrorVisuals(emailValidator(event.target.value), usernameInput, usernameError)
        }
    })
}

if (forgotPasswordInput) {
    forgotPasswordInput.addEventListener('input', function (event) {
        forgotPasswordValue = event.target.value
        if (hasUserTriedSubmit) {
            displayErrorVisuals(emailValidator(event.target.value), forgotPasswordInput, forgotPasswordError)
        }
    })
}

const formTypeValidateDictionary = function(formIdentifier) {
    switch (formIdentifier) {
        case 'login':
            return {
                isEmail : emailValidator(usernameValue),
                inputField : usernameInput, 
                errorMsgElement : usernameError
            }
            break
        case 'forgotPassword':
            return {
                isEmail : emailValidator(forgotPasswordValue),
                inputField : forgotPasswordInput, 
                errorMsgElement : forgotPasswordError
            }
            break
        default:
            console.log(`No forms to validate found for identifier: ${formIdentifier}.`)
        }
}

const validateLoginFormInput = function(formIdentifier) {
    hasUserTriedSubmit = true     
    let formToValidate = formTypeValidateDictionary(formIdentifier)
    
    if (!formToValidate.isEmail) {
        displayErrorVisuals(formToValidate.isEmail, formToValidate.inputField, formToValidate.errorMsgElement)
    } 
    return formToValidate.isEmail
} 


const displayErrorVisuals = function(isEmail, inputField, errorMsgElement) {
    if (!isEmail && !inputField.validity.valueMissing) {
        inputField.classList.add('nlx-login-page__error-border--active')
        errorMsgElement.classList.add('nlx-login-page__error-text--active')
    } else {
        inputField.classList.remove('nlx-login-page__error-border--active')
        errorMsgElement.classList.remove('nlx-login-page__error-text--active')
    }
}


window.validateLoginFormInput = validateLoginFormInput